import { MessageHistoryItem } from '@rbx/conv-ai-provider';
import { Locale } from '@rbx/intl';

const getMessageLogParams = ({
  message,
  conversationId,
  locale,
  messageContentPropName = 'messageContent',
}: {
  message?: MessageHistoryItem;
  conversationId?: string;
  locale?: Locale | string | null;
  messageContentPropName?: string;
}) => ({
  locale: locale ?? '',
  messageId: message?.requestId ?? '',
  requestIdV2: message?.requestId ?? '',
  messageIdV2: message?.messageId ?? '',
  role: String(message?.role ?? ''),
  conversationId: conversationId ?? '',
  [messageContentPropName]: message?.content ?? '',
  prompt: message?.context.prompt ?? '',
  originalPrompt: message?.context.originalPrompt ?? '',
  requestType: message?.context.requestType ?? '',
});

export default getMessageLogParams;
